import { render, staticRenderFns } from "./gs.vue?vue&type=template&id=823f6e18&scoped=true"
var script = {}
import style0 from "./gs.vue?vue&type=style&index=0&id=823f6e18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823f6e18",
  null
  
)

export default component.exports